"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function recalculateWarnings({ validate, }) {
    return (state, actions, { tabName = state.ui.currentTabName }) => () => {
        const validationState = actions.getters.getImagePropertiesValidationState();
        const validationResults = validate({ validationState });
        actions.setters.setWarnings({ validationResults });
    };
}
exports.recalculateWarnings = recalculateWarnings;
//# sourceMappingURL=recalculate-warnings.js.map